import React, { useEffect, useMemo, useState } from "react";
import styles from "../../styles/chat.module.scss";
import TypingEffect from "../TypingEffect";
import {
  DownOutlined,
  EditOutlined,
  EnterOutlined,
  FileZipOutlined,
  MergeFilled,
  RotateRightOutlined,
  SyncOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { Alert, Badge, Button, Input, Space, Steps, Tooltip } from "antd";
import { changeHistory } from "../api/mermaidChart";
import ReactMarkdown from "react-markdown";

export default function ChatItem(props: {
  isLast: boolean;
  item: any;
  goToBottom: () => void;
  handleCopy: any;
  thread_id: string;
  reAsk: (value: string, item: any) => void;
  umlReloadSuccess: (str: string, uuid: string) => void;
  reAnswer: (uuid: string) => void;
  stop: boolean;
  handleClickRepo: (
    params: {
      type: string;
      repo_full_name: string;
      branch_name: string;
      url?: string;
    },
    action?: "quote" | "preview",
    fileInfo?: {
      openai_file_id?: string;
      original_filename?: string;
      startLine?: number;
      endLine?: number;
    }
  ) => void;
}) {
  const {
    isLast,
    item,
    goToBottom,
    handleCopy,
    reAsk,
    umlReloadSuccess,
    reAnswer,
    stop,
    handleClickRepo,
  } = props;
  const [msgdata, setMsgdata] = useState<any>(item);
  const [editState, setEditState] = useState(false);
  const [value, setValue] = useState(item.text);
  const [close, setClose] = useState(!item.pending);
  const { TextArea } = Input;
  useEffect(() => {
    setMsgdata(item);
  }, [item]);
  const markDown = useMemo(() => {
    return (
      <TypingEffect
        stop={msgdata.pending}
        pending={msgdata.pending}
        goToBottom={goToBottom}
        text={msgdata.text}
        uuid={msgdata.uuid}
        thread_id={props.thread_id}
        umlReloadSuccess={umlReloadSuccess}
        onOpenCodeLink={(
          path: string,
          fileName?: string,
          branch_name?: string,
          startLine?: number,
          endLine?: number
        ) => {
          handleClickRepo(
            {
              type: branch_name ? "github" : "local",
              repo_full_name: fileName || "",
              branch_name: branch_name || "master",
            },
            "preview",
            {
              openai_file_id: path,
              original_filename: fileName,
              startLine: startLine,
              endLine: endLine,
            }
          );
        }}
      />
    );
  }, [msgdata.pending, msgdata.text, msgdata.uuid, props.thread_id]);
  const ItemChat = React.useMemo(() => {
    return (
      <>
        {msgdata.user_type == "user" && msgdata.text && (
          <div className={styles.chatpdfRow}>
            <div className={styles.chatpdfAsk}>
              <div className={styles.askBox}>
                {!msgdata.file_name && !stop && (
                  <div className={styles.chatAskEdit}>
                    <div className={styles.chatAskEditBtn}>
                      {!editState && (
                        <Button
                          shape="circle"
                          type="text"
                          size="large"
                          onClick={() => {
                            setValue(msgdata.text);
                            setEditState(true);
                          }}
                          icon={<EditOutlined />}
                        />
                      )}
                    </div>
                  </div>
                )}
                {editState ? (
                  <div className={styles.chatAskEditBox}>
                    <TextArea
                      value={value}
                      onChange={(e) => {
                        setValue(e.target.value);
                      }}
                      style={{
                        background: "var(--chat-ask-bg)",
                        border: "none",
                        boxShadow: "none",
                      }}
                      autoSize={{ minRows: 2, maxRows: 6 }}
                    />
                    <Space style={{ marginTop: "5px" }}>
                      <Button
                        shape="round"
                        type="default"
                        onClick={() => {
                          setEditState(false);
                          setValue(msgdata.text);
                        }}
                      >
                        取消
                      </Button>
                      <Button
                        shape="round"
                        color="default"
                        variant="solid"
                        onClick={() => {
                          reAsk(value, msgdata);
                          setEditState(false);
                        }}
                      >
                        发送
                      </Button>
                    </Space>
                  </div>
                ) : (
                  <div className={styles.chatAskPdfContent}>
                    <pre>{msgdata.text}</pre>
                  </div>
                )}
                {/* <div className={styles.chatpdfIcon}></div> */}
              </div>
              {/* 仓库名 */}
              {Object.keys(msgdata?.metadata?.repository || {}).length > 0 && (
                <div className={styles.chatAskMeta}>
                  <div className={styles.flexBox}>
                    <MergeFilled style={{ fontSize: 24 }} />
                    <div
                      className={styles.overflowText}
                      title={msgdata?.metadata?.repository.url}
                    >
                      <div className={styles.url}>
                        {msgdata?.metadata?.repository.url}
                      </div>
                      <div className={styles.branch_name}>
                        {msgdata?.metadata?.repository.branch_name}
                      </div>
                    </div>
                    <Space>
                      <Tooltip placement="top" title="引用">
                        <Button
                          type="default"
                          size="small"
                          shape="circle"
                          className={styles.btn}
                          icon={<RotateRightOutlined />}
                          onClick={() => {
                            handleClickRepo(
                              msgdata?.metadata?.repository,
                              "quote"
                            );
                          }}
                        />
                      </Tooltip>
                      <Button
                        type="default"
                        size="small"
                        shape="round"
                        className={styles.btn}
                        onClick={() => {
                          handleClickRepo(
                            msgdata?.metadata?.repository,
                            "preview"
                          );
                        }}
                      >
                        查看
                      </Button>
                    </Space>
                  </div>
                </div>
              )}
              {!!msgdata?.metadata?.file_name && (
                <div className={styles.chatAskMeta}>
                  <div className={styles.flexBox}>
                    <FileZipOutlined style={{ fontSize: 24 }} />
                    <div
                      className={styles.overflowText}
                      title={msgdata?.metadata?.file_name}
                    >
                      {msgdata?.metadata?.file_name}
                    </div>
                    <Space>
                      <Tooltip placement="top" title="引用">
                        <Button
                          type="default"
                          size="small"
                          shape="circle"
                          className={styles.btn}
                          icon={<RotateRightOutlined />}
                          onClick={() => {
                            handleClickRepo(
                              {
                                type: "local",
                                repo_full_name: msgdata?.metadata?.file_name,
                                branch_name: "master",
                              },
                              "quote",
                              {
                                openai_file_id: msgdata.file_id || "",
                                original_filename:
                                  msgdata?.metadata?.file_name || "",
                              }
                            );
                          }}
                        />
                      </Tooltip>
                      <Button
                        type="default"
                        size="small"
                        shape="round"
                        className={styles.btn}
                        onClick={() => {
                          handleClickRepo(
                            {
                              type: "local",
                              repo_full_name: msgdata?.metadata?.file_name,
                              branch_name: "master",
                            },
                            "preview"
                          );
                        }}
                      >
                        查看
                      </Button>
                    </Space>
                  </div>
                </div>
              )}
              {item.code_snippet?.file_path && (
                <div className={styles.quote}>
                  <span className={styles.quoteBox}>
                    <span className={styles.text}>
                      {item.code_snippet?.file_path}
                    </span>
                    {item.code_snippet?.start_line?.toString() &&
                      item.code_snippet?.end_line?.toString() && (
                        <span className={styles.text}>
                          ( {item.code_snippet?.start_line?.toString()}-
                          {item.code_snippet?.end_line?.toString()})
                        </span>
                      )}
                  </span>
                </div>
              )}
            </div>
          </div>
        )}
        {msgdata.user_type == "assistant" && (
          <div className={styles.chatpdfRow}>
            <div
              className={
                msgdata.assistant_id?.toString() === "1"
                  ? styles.chatpdfIcon
                  : styles.chatpdfIcon
              }
            ></div>

            {msgdata.text != "当前对话不存在" &&
              msgdata.text != "订阅已到期" &&
              msgdata.text !=
                "您的今日试用对话机会已用完，请明天继续使用，或者进行会员订阅" && (
                <div className={styles.chatpdfContent}>
                  {(msgdata.thinking_text || !msgdata.text) && (
                    <div className={styles.loadingContainer}>
                      <div className={styles.thinking}>
                        <div className={styles.thinkingBtnBox}>
                          <div
                            className={styles.thinkingBtn}
                            onClick={() => {
                              setClose(!close);
                            }}
                          >
                            <span className={styles.thinkingTitle}>
                              Eagle {msgdata.pending ? "思考中..." : "已思考"}
                            </span>
                            {msgdata.thinking_text ? (
                              close ? (
                                <DownOutlined />
                              ) : (
                                <UpOutlined />
                              )
                            ) : null}
                          </div>
                        </div>

                        {!!msgdata.thinking_text && !close && (
                          <div className={styles.thinkingText}>
                            <ReactMarkdown>
                              {msgdata.thinking_text}
                            </ReactMarkdown>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                  {msgdata.text !== "" && markDown}
                  {!msgdata.pending && msgdata.text !== "" && (
                    <div className={styles.toolBtns}>
                      <Tooltip placement="top" title="复制">
                        <div
                          className={styles.toolItem}
                          onClick={() => handleCopy(msgdata.text)}
                        >
                          <div className={styles.copyIcon} />
                        </div>
                      </Tooltip>
                      {!stop && (
                        <Tooltip placement="top" title="重新回答">
                          <div
                            className={styles.toolItem}
                            onClick={() => reAnswer(msgdata.uuid)}
                          >
                            <SyncOutlined />
                          </div>
                        </Tooltip>
                      )}
                      {/* <Tooltip placement="top" title="喜欢">
                          <div className={styles.toolItem}>
                            {msgdata.is_effective === 1 ? (
                              <LikeFilled />
                            ) : (
                              <LikeOutlined
                                onClick={() => handleLikeOrNot(1)}
                              />
                            )}
                          </div>
                        </Tooltip>
                        <Tooltip placement="top" title="不喜欢">
                          <div className={styles.toolItem}>
                            {msgdata.is_effective === 2 ? (
                              <DislikeFilled />
                            ) : (
                              <DislikeOutlined
                                onClick={() => handleLikeOrNot(2)}
                              />
                            )}
                          </div>
                        </Tooltip> */}
                    </div>
                  )}
                  {/* {!msgdata.pending &&
                    msgdata.text !== "loading" &&
                    msgdata.text !== "" &&
                    msgdata.is_effective !== 1 &&
                    msgdata.is_effective !== 2 && (
                      <div className={styles.toolBtns}>
                        <Alert
                          message="请对Eagle的回答进行反馈，方便我们提供更好的服务"
                          key={msgdata.uuid}
                          type="info"
                        />
                      </div>
                    )} */}
                </div>
              )}
          </div>
        )}
      </>
    );
  }, [msgdata, editState, value, isLast, stop, close]);
  return ItemChat;
}
